import { Button } from "reactstrap";

export const DetailsButton = ({ toggleModalState, setValues, original }) => {
  return (
    <Button
      color="info"
      onClick={() => {
        toggleModalState(true);
        setValues({ ...original, isDisabled: true });
      }}
    >
      Dett.
    </Button>
  );
};
